export default {"src":"/_next/static/media/place.30755832.svg","height":24,"width":24};